//js included on every page

import $ from "jquery";

//NOTE: bootstrap imports in main.js must reference the specific src component, not the usual bootstrap.[bundle/esm].js file
//		importing componenets the usual way loads Popper twice, which breaks the Dropdown component
import Alert from 'bootstrap/js/src/alert';
import Tooltip from 'bootstrap/js/src/tooltip';


//initialize tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(tooltip => {
	new Tooltip(tooltip,{
		container: 'body',
		trigger: 'hover'
	});
});


//dismiss specific alerts after a set amount of time
document.querySelectorAll('.alert[data-timeout]').forEach(alert => {
	const timeout = alert.getAttribute('data-timeout');
	setTimeout(() => {
		Alert.getOrCreateInstance(alert).close();
	}, timeout);
});


//fix 'Blocked aria-hidden because descendant retained focus' error
window.addEventListener('hide.bs.modal', () => {
	if (document.activeElement instanceof HTMLElement) {
		document.activeElement.blur();
	}
});


// handle toggling of column children
$('#column').on('click', '.has-children > a', function (e) {
	e.preventDefault();
	if ($(this).parent().hasClass('active') && $('body').hasClass('expanded')) {
		$('body').removeClass('expanded');
	} else {
		$('body').addClass('expanded');
		$(this).parent().siblings().removeClass('active');
		$(this).parent().addClass('active');
	}
});

$(document).on('touchstart', function () {
	documentClick = true;
});

$(document).on('touchmove', function () {
	documentClick = false;
});

$(document).on('click touchend', function (e) {
	if (e.type === 'click') documentClick = true;
	if (documentClick) {
		hideNav(true);
	}
});

$('.close-nav').on('click', function (e) {
	e.preventDefault();
	hideNav(true);
});

// stop propagation of clicks on subnav
$('#column').on('click touchend', function (e) {
	e.stopPropagation();
});

$('#column').on('click', 'a', function (e) {
	if ($(this).attr('href') !== '#') {
		e.preventDefault();
		if (!$(this).parent().hasClass('active')) {
			$('#main').addClass('fade-out');
			hideNav();
			href = $(this).attr('href');
			window.setTimeout(function () {
				window.location.href = href;
			}, 500);
		}
	}
});

function hideNav(returnPreviousState) {
	if ($('body').hasClass('expanded')) {
		$('body').removeClass('expanded');
		if (returnPreviousState === true) {
			$('#column .active').removeClass('active');
			$('#column .current').addClass('active');
		}
	}
}
